export const GET_AGREEMENTS_REQUEST = 'user.investor.GET_AGREEMENTS_REQUEST'
export const GET_AGREEMENTS_SUCCESS = 'user.investor.GET_AGREEMENTS_SUCCESS'
export const GET_AGREEMENTS_FAILURE = 'user.investor.GET_AGREEMENTS_FAILURE'
export const POST_SKIP_SIGNED_AGREEMENTS_SUCCESS =
  'user.investor.POST_SKIP_SIGNED_AGREEMENTS_SUCCESS'
